/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TimeBudgetData_project = {
    readonly " $fragmentRefs": FragmentRefs<"TimeChart_project" | "TimeTotals_project" | "HighLevelTimeNumbers_project">;
    readonly " $refType": "TimeBudgetData_project";
};
export type TimeBudgetData_project$data = TimeBudgetData_project;
export type TimeBudgetData_project$key = {
    readonly " $data"?: TimeBudgetData_project$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TimeBudgetData_project">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentYear",
      "type": "Int"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentMonth",
      "type": "Int"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentMonthLastDay",
      "type": "Int"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeBudgetData_project",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimeChart_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimeTotals_project"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "currentMonth",
          "variableName": "currentMonth"
        },
        {
          "kind": "Variable",
          "name": "currentMonthLastDay",
          "variableName": "currentMonthLastDay"
        },
        {
          "kind": "Variable",
          "name": "currentYear",
          "variableName": "currentYear"
        }
      ],
      "kind": "FragmentSpread",
      "name": "HighLevelTimeNumbers_project"
    }
  ],
  "type": "ProjectType"
};
(node as any).hash = 'b854853a53bd6cfb170bfc6a2f5dfd7b';
export default node;
